module.exports = __webpack_public_path__ + "bundle/assets/item-arrow-opened-white.7349be99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/assets/item-arrow-opened-white.svg
// module id = 65
// module chunks = 0